import InsightsSimpleNumberWidget from 'components/InsightsSimpleNumberWidget/InsightsSimpleNumberWidget'

export default InsightsSimpleNumberWidget
